<template>
  <div class="workbench-content" v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(255, 255, 255, 0.3)">
    <div class="header-row">
      <div class="page-title">
        <img :src="iconImg" class="title-icon" />
        <span class="main-title">在售品信息通知</span>
        <div class="title-decoration">
          <img :src="titleImg" class="title-decoration-img" />
        </div>
      </div>
      <div class="tab-wrapper">
        <div class="tab-item" v-for="(tab, index) in stroeTabs" :key="index" :class="{ active: activeTab === index }" @click="handleTabClick(tab, index)">
          {{ tab.storeName }}
        </div>
      </div>
    </div>

    <div class="main-area">
      <div class="left-stats">
        <div class="stats-row" v-for="(row, rowIndex) in statsRows" :key="rowIndex">
          <div class="row-title-area">
            <div class="row-title">{{ row.adjustContent }}</div>
            <div class="row-arrow">
              <span class="el-icon-arrow-right"></span>
              <span class="el-icon-arrow-right"></span>
            </div>
          </div>

          <div class="stat-item main-stat" @click="handleStatClick(row, 'total')">
            <div class="stat-value text-green">{{ row.totalQty }}</div>
            <div class="stat-label">
              {{ getStatLabel(row.adjustContent, '待处理商品总计') }}
              <el-tooltip :content="getStatLabel(row.adjustContent, '延期待处理商品 + 正常待处理商品')" placement="top">
                <i class="el-icon-question help-icon"></i>
              </el-tooltip>
            </div>
          </div>

          <div class="divider"></div>

          <div class="stat-item" @click="handleStatClick(row, 'emergency')">
            <div class="stat-value text-yellow">{{ row.emergencyQty }}</div>
            <div class="stat-label">
              {{ getStatLabel(row.adjustContent, '紧急待处理商品') }}
              <el-tooltip :content="getStatLabel(row.adjustContent, '紧急待处理商品包含部分【延期待处理】和【正常待处理商品】；')" placement="top">
                <i class="el-icon-question help-icon"></i>
              </el-tooltip>
            </div>
          </div>

          <div class="divider"></div>

          <div class="stat-item" @click="handleStatClick(row, 'delay')">
            <div class="stat-value text-orange">{{ row.delayQty }}</div>
            <div class="stat-label">{{ getStatLabel(row.adjustContent, '延期待处理商品') }}</div>
          </div>

          <div class="stat-item" @click="handleStatClick(row, 'normal')">
            <div class="stat-value text-yellow">{{ row.normalQty }}</div>
            <div class="stat-label">{{ getStatLabel(row.adjustContent, '正常待处理商品') }}</div>
          </div>
        </div>
      </div>

      <div class="right-rankings">
        <div class="table-box table-box-with-header">
          <div class="panel-header">
            <span class="panel-title">待处理平均耗时排名</span>
            <el-tooltip
              content="耗时统计为店铺下所有类型汇总相加各商品的（操作已处理或未上架的时间 – 商品通知时间） / 商品数，并根据各店铺的平均耗时进行统计数据排名"
              placement="top"
            >
              <i class="el-icon-question help-icon"></i>
            </el-tooltip>
          </div>
          <div class="panel-content">
            <div class="table-header-row">
              <span class="th name">店铺</span>
              <span class="th value">耗时天数</span>
              <span class="th rank">排名</span>
            </div>
            <div class="table-body">
              <div class="table-row" v-for="item in leftTableData" :key="item.rank" :class="{ 'highlight-row': item.storeName === currentStoreName }">
                <span class="td name">{{ item.storeName }}</span>
                <span class="td value">{{ item.days }}</span>
                <span class="td rank">{{ item.rank }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="table-box table-box-no-header">
          <div class="panel-header">
            <span class="panel-title">待处理商品总数排名</span>
            <el-tooltip content="根据各店铺所有类型的待处理商品进行统计数据排名" placement="top">
              <i class="el-icon-question help-icon"></i>
            </el-tooltip>
          </div>
          <div class="panel-content">
            <div class="table-header-row">
              <span class="th name">店铺</span>
              <span class="th value">待处理总数</span>
              <span class="th rank">排名</span>
            </div>
            <div class="table-body">
              <el-tooltip v-for="item in rightTableData" :key="item.rank" effect="light" placement="top" :open-delay="500" popper-class="shooting-tooltip">
                <div slot="content" class="tooltip-content">
                  <div class="tooltip-item">
                    <div class="tooltip-label">紧急待处理</div>
                    <div class="tooltip-value">{{ item.emergencyQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">延期待处理</div>
                    <div class="tooltip-value">{{ item.delayQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">正常待处理</div>
                    <div class="tooltip-value">{{ item.normalQty || 0 }}</div>
                  </div>
                </div>
                <div class="table-row" :class="{ 'highlight-row': item.storeName === currentStoreName }">
                  <span class="td name">{{ item.storeName }}</span>
                  <span class="td value">{{ item.totalQty }}</span>
                  <span class="td rank">{{ item.rank }}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBoxImg from '@/assets/images/workbench_img/headerBox.png';
import titleImg from '@/assets/images/workbench_img/title.png';
import iconImg from '@/assets/images/workbench_img/icon.png';

export default {
  name: 'ProductChange',
  computed: {
    currentStoreName() {
      const store = this.stroeTabs.find((item) => item.storeCode === this.storeCode);
      return store ? store.storeName : '';
    },
  },
  data() {
    return {
      activeTab: 0,
      stroeTabs: [],
      headerBoxImg,
      titleImg,
      iconImg,
      statsRows: [],
      leftTableData: [],
      rightTableData: [],
      storeCode: '',
      loading: false,
    };
  },
  mounted() {
    this.queryOnSaleStore();
  },
  methods: {
    /**
     * 根据 adjustContent 获取标签文字
     * @param {string} adjustContent - 调整内容类型
     * @param {string} label - 原始标签，包含"商品"文字
     * @returns {string} 处理后的标签
     */
    getStatLabel(adjustContent, label) {
      if (adjustContent === '设计图') {
        return label.replace(/商品/g, '型号');
      }
      return label;
    },
    async initData() {
      this.loading = true;
      await this.getWbOnSaleData();
      await this.getOnSaleStoreRank();
      await this.getOnSaleGoodsRank();
      this.loading = false;
    },
    handleTabClick(tab, index) {
      this.activeTab = index;
      this.storeCode = tab.storeCode;
      this.initData();
    },
    queryOnSaleStore() {
      return this.$q.dataBoard.queryOnSaleStore().then((res) => {
        this.stroeTabs = res.data;
        this.storeCode = this.stroeTabs[0].storeCode;
        this.initData();
      });
    },
    getWbOnSaleData() {
      const params = {
        params: {
          storeCode: this.storeCode,
        },
      };
      return this.$q.dataBoard.getWbOnSaleData(params).then((res) => {
        this.statsRows = res.data;
      });
    },
    getOnSaleStoreRank() {
      let data = {
        pageNum: 1,
        pageSize: 999,
        filterData: {
          storeCode: this.storeCode,
        },
      };
      return this.$q.dataBoard.getOnSaleStoreRank({ data }).then((res) => {
        this.leftTableData = res.data.list;
      });
    },
    getOnSaleGoodsRank() {
      let data = {
        pageNum: 1,
        pageSize: 999,
        filterData: {
          storeCode: this.storeCode,
        },
      };
      return this.$q.dataBoard.getOnSaleGoodsRank({ data }).then((res) => {
        this.rightTableData = res.data.list;
      });
    },
    handleStatClick(row, type) {
      let query = {
        parentTab: 'ToBeProcessed',
      };

      if (row.adjustContent.includes('价格')) {
        query.activeTab = 'price';
      } else if (row.adjustContent.includes('设计图')) {
        query.activeTab = 'design';
      } else if (row.adjustContent.includes('通栏图')) {
        query.activeTab = 'banner';
      } else if (row.adjustContent.includes('销售状态') || row.adjustContent.includes('发货周期') || row.adjustContent.includes('是否松木')) {
        query.activeTab = 'other';
        query.adjustContentQuery = row.adjustContent;
      }

      if (type === 'emergency') {
        query.emergency = '1';
      } else if (type === 'delay') {
        query.delayStatus = '1';
      } else if (type === 'normal') {
        query.delayStatus = '0';
      }
      this.$router.push({
        path: '/newProduct/fast-product-arrival',
        query: query,
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.workbench-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: url('../../../../assets/images/workbench_img/content.png') no-repeat center;
  background-size: 100% 100%;
  padding-bottom: 25px
  height: 800px; /* Increased height */
  gap: 15px;
  margin-top: 10px;
}

.header-row {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 10px
    border-left: 3px solid #95FEFF
    background: linear-gradient(90deg, rgba(0,60,50,0.5) 0%, rgba(0,0,0,0) 100%);
    margin-bottom: 5px;
}

.page-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 30px;
}

.title-icon {
    height: 20px;
    margin-right: 5px;
}

.main-title {
    font-size: 20px;
    font-family: 'FZLTTH';
    letter-spacing: 1px;
    background: linear-gradient(180deg, #FFFFFF 0%, #B1FFFC 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.title-decoration {
    margin-left: 10px;
    display: flex;
    align-items: center;
}

.title-decoration-img {
    height: 16px;
    opacity: 0.7;
}

.tab-wrapper {
    display: flex;
    gap: 0;
    margin-left: 10px;
    border: 1px solid rgba(123, 255, 224, 0.3);
    border-radius: 2px;
    background: rgba(123,255,224,0.1);
}

.tab-item {
    padding: 6px 20px;
    background: rgba(5, 72, 56, 0.6);
    color: #8DEDDD;
    font-size: 13px;
    cursor: pointer;
    border-right: none;
    transition: all 0.3s ease;
    font-family: 'AlibabaHuiTi', sans-serif;

    &:first-child {
        border-radius: 2px 0 0 2px;
    }

    &:last-child {
        border-radius: 0 2px 2px 0;
    }

    &:hover {
        background: rgba(11, 183, 142, 0.3);
    }

    &.active {
        background: rgba(11, 133, 127, 0.6);
        color: #fff;
        text-shadow: 0px 0px 8px rgba(123,255,224,0.8), 0px 0px 12px rgba(123,255,224,0.5);
    }
}

.main-area {
    display: flex;
    padding: 0 20px;
    gap: 10px;
    height: 100%;
    overflow: hidden;
}

.left-stats {
    flex: 3;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.stats-row {
    flex: 1;
    background: rgba(5, 72, 56, 0.6);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 20px;
}

.row-title-area {
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-family: 'AlibabaHuiTi', sans-serif;
    margin-right: 20px;
}

.row-title {
    font-size: 16px; /* Increased font size */
    margin-bottom: 5px;
    font-family: 'AlibabaHuiTi', sans-serif;
    text-shadow: 0px 0px 8px rgba(123,255,224,0.8), 0px 0px 12px rgba(123,255,224,0.5);
}

.row-arrow {
    font-size: 30px;
    transform: scaleY(0.6);
    display: flex;
    align-items: center;
    color: #fff;

    span {
        &:last-child {
            margin-left: -12px;
        }
    }
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    cursor: pointer;
}

.stat-item.main-stat {
    flex: 1.2;
}

.stat-value {
    font-family: 'PingFangBold', sans-serif;
    font-size: 40px; /* Increased font size */
    font-weight: bold;
    margin-bottom: 8px;
}

.stat-label {
    font-size: 14px; /* Increased font size */
    color: #fff;
    font-family: 'AlibabaHuiTi', sans-serif;
    display: flex;
    align-items: center;
    gap: 5px;
}

.help-icon {
    font-size: 14px;
    color: rgba(255,255,255,0.5);
    cursor: pointer;
}

.text-green { color: #4BEDD2; }
.text-yellow { color: #FFF6A4; }
.text-orange { color: #F0714B; }

.divider {
    width: 1px;
    height: 40px;
    background: #40888A;
    margin: 0 20px;
}

.right-rankings {
    flex: 2;
    display: flex;
    gap: 10px;
}

.table-box {
    flex: 1;
    position: relative;
    background: rgba(5, 72, 56, 0.6);
    padding: 0;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
}

.panel-header {
    display: flex;
    align-items: center;
    height: 42px;
    background: url('../../../../assets/images/workbench_img/headerBox.png') no-repeat center;
    background-size: 100% 100%;
    padding-left: 10px;
    margin-bottom: 0;
    width: calc(20vw - 60px);
    font-family: 'FZLTZHK', sans-serif;
}

.panel-title {
    font-size: 14px;
    margin-right: 5px;
    color: #fff;
}

.panel-content {
    flex: 1;
    overflow: hidden;
    padding: 10px;
    display: flex;
    flex-direction: column;
}

.table-header-row {
    display: flex;
    padding: 8px 0;
    color: #8DEDDD;
    font-size: 14px; /* Increased font size */
}

.th, .td {
    text-align: center;
}

.th.name, .td.name { flex: 1; }
.th.value, .td.value { flex: 1; }
.th.rank, .td.rank { flex: 0.6; }

.table-body {
    flex: 1;
    overflow-y: auto;
    padding-top: 5px;
}

.table-row {
    display: flex;
    padding: 8px 0; /* Increased padding */
    font-size: 14px; /* Increased font size */
    color: #fff;
    border-bottom: 1px solid #1D6052;
    border-left: 1px solid #1D6052;
    border-right: 1px solid #1D6052;
    background: #0B5042;

    &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    &:last-child {
        border-bottom: none;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    &:hover {
      cursor: pointer
      // background: rgba(11, 133, 127, 0.6)
    }
}

.highlight-row {
  background: rgba(11, 133, 127, 0.6) !important;
}

::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
::-webkit-scrollbar-track {
    background: rgba(255,255,255,0.02);
}
::-webkit-scrollbar-thumb {
    background: rgba(46, 249, 198, 0.2);
    border-radius: 2px;
}
</style>

<style lang="stylus">
.shooting-tooltip {
  .tooltip-content {
    display: flex;
    gap: 20px;
    text-align: center;
  }
  .tooltip-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .tooltip-label {
    font-size: 12px;
    color: #333;
    margin-bottom: 5px;
  }
  .tooltip-value {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
</style>
